import { render, staticRenderFns } from "./ShotLinkList.vue?vue&type=template&id=2354c978&scoped=true"
import script from "./ShotLinkList.vue?vue&type=script&lang=js"
export * from "./ShotLinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354c978",
  null
  
)

export default component.exports